import React, { forwardRef } from 'react';

const overlayStyle = {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 50,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // bg-black/80 equivalent
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem'
};

const contentStyle = {
    position: 'relative',
    display: 'grid',
    width: '100%',
    maxWidth: '32rem', // max-w-lg
    gap: '1rem',
    border: '1px solid #e2e8f0',
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    borderRadius: '0.5rem'
};

const headerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.375rem',
    // 13.09.2026 quick-260913-g58: ключ textAlign был объявлен ДВАЖДЫ
    // ('center', потом 'left'), побеждало ВТОРОЕ — центрирование не
    // применялось НИКОГДА. Оставлено то, что действует сейчас, чтобы
    // починка дефекта не стала молча правкой вида.
    // 🙋 ОТЗЫВЧИВОГО поведения (center на узком экране, left от sm) тут
    //    НЕТ и никогда не было — нужно ли оно, решает владелец.
    textAlign: 'left'
};

const titleStyle = {
    fontSize: '1.125rem',
    fontWeight: '600',
    lineHeight: '1',
    letterSpacing: '-0.025em'
};

const descriptionStyle = {
    fontSize: '0.875rem',
    color: '#64748b' // slate-500
};

export const Dialog = ({ children, open, onOpenChange }) => {
    if (!open) return null;

    return (
        <div style={overlayStyle} onClick={(e) => {
            if (e.target === e.currentTarget) onOpenChange(false);
        }}>
            {children}
        </div>
    );
};

export const DialogContent = forwardRef(({ className, children, style, ...props }, ref) => (
    <div
        ref={ref}
        style={{ ...contentStyle, ...style }}
        {...props}
    >
        {children}
    </div>
));
DialogContent.displayName = "DialogContent";

export const DialogHeader = ({ className, style, ...props }) => (
    <div style={{ ...headerStyle, ...style }} {...props} />
);
DialogHeader.displayName = "DialogHeader";

export const DialogTitle = forwardRef(({ className, style, ...props }, ref) => (
    <h2
        ref={ref}
        style={{ ...titleStyle, ...style }}
        {...props}
    />
));
DialogTitle.displayName = "DialogTitle";

export const DialogDescription = forwardRef(({ className, style, ...props }, ref) => (
    <p
        ref={ref}
        style={{ ...descriptionStyle, ...style }}
        {...props}
    />
));
DialogDescription.displayName = "DialogDescription";

export const DialogFooter = ({ className, style, ...props }) => (
    <div
        style={{
            display: 'flex',
            flexDirection: 'column-reverse',
            // sm:flex-row sm:justify-end sm:space-x-2
            gap: '0.5rem',
            marginTop: '1rem',
            ...style
        }}
        {...props}
    />
);
DialogFooter.displayName = "DialogFooter";
